import {
    addLidarController,
    fetchLidarDeviceDetails,
    updateLidarController,
    updateLidarControllerStatus
} from "../network/LidarOverviewNetworkAPI";
import {fetchScanlessOfflineDeviceDetails} from "../network/LidarManageByExceptionsNetworkAPI";

export const LidarOverviewReducer = (state, action) => {
    switch (action.type) {
        case "RECEIVE_DATA":
            return {...state, ...action.data, loadingOverview: false}
        case "LOAD_VIEW":
            fetchLidarDeviceDetails(action.data.dispatcher)
            return state
        case "LOAD_MANAGE_BY_EXCEPTIONS_VIEW":
            fetchScanlessOfflineDeviceDetails(action.data.dispatcher)
            return state
        case "SORT_DATA":
            return {...state, sortPref: action.data}
        case "ADD_LIDAR_CONTROLLER":
            addLidarController(action.data.dispatcher, action.data.stateValues,
                action.data.showCustomAlert)
            return state
        case "UPDATE_LIDAR_CONTROLLER":
            updateLidarController(action.data.dispatcher, action.data.stateValues,
                action.data.showCustomAlert)
            return state
        case "UPDATE_DEVICE_STATUS":
            updateLidarControllerStatus(action.data.dispatcher, action.data.mac, action.data.status,
                action.data.showCustomAlert)
            return state
        case "DELETE_DEVICE_DATA":
            updateLidarControllerStatus(action.data.dispatcher, action.data.mac, "DEPRECATED",
                action.data.showCustomAlert)
            return state
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/lidar/reducer/LidarOverviewReducer.js